export default class Company {
  id: number;
  full_name: string;
  comercial_name: string;

  constructor(data: any) {
    this.id = data.id;
    this.full_name = data.full_name;
    this.comercial_name = data.comercial_name;

    return this;
  }

  setfull_name(v: string) {
    this.full_name = v;
  }

  get nameToShow() {
    return this.comercial_name ? this.comercial_name : this.full_name;
  }
}

export enum CompanyContactType {
  Administracion = 0,
  Logistica = 1,
  IngenieroAgronomo = 2,
  OperativoDeCampo = 3,
  DuenoDeEquipo = 4,
  DuenoDeMaquina = 5,
  EncargadoDeCampo = 6,
  AsesorAgronomico = 7,
  Otro = 8,
}

export const CompanyContactTypeString = {
  [CompanyContactType.Administracion]: 'Administracion',
  [CompanyContactType.Logistica]: 'Logistica',
  [CompanyContactType.IngenieroAgronomo]: 'Ingeniero Agronomo',
  [CompanyContactType.OperativoDeCampo]: 'Operativo de Campo',
  [CompanyContactType.DuenoDeEquipo]: 'Dueno de Equipo',
  [CompanyContactType.DuenoDeMaquina]: 'Dueno de Maquina',
  [CompanyContactType.EncargadoDeCampo]: 'Encargado de Campo',
  [CompanyContactType.AsesorAgronomico]: 'Asesor Agronomico',
  [CompanyContactType.Otro]: 'Otro',
};
